import API from "@/http/http-client";
import IIdentifier from "@/interfaces/models/identifier.interface";

export const IdentifierService = {
  async fetchIdentifier(): Promise<IIdentifier[]> {
    const {data} = await API.get('/dog/message-identifiers');
    return data;
  },
}
